import { Input } from 'rsuite'
import { getIn } from 'formik'
import { FormikInputs } from './interfaces'
import TextInputNumber from './TextInputNumber'

function TextInput<V>(props: Readonly<FormikInputs<V>>): React.ReactElement {
  const {
    formik,
    dataType = 'string',
    placeholder = '',
    isDisabled,
    name,
    ...rest
  } = props

  const fieldValue = getIn(formik?.values, name) ?? ''

  if (dataType === 'number') {
    return (
      <TextInputNumber
        formik={formik}
        name={name}
        isDisabled={isDisabled}
        placeholder={placeholder}
        {...rest}
      />
    )
  }

  return (
    <Input
      name={name}
      data-testid={name}
      type={dataType}
      value={
        typeof fieldValue === 'string' || typeof fieldValue === 'number'
          ? fieldValue
          : ''
      }
      disabled={isDisabled}
      placeholder={placeholder}
      onChange={(value: string) => {
        formik?.setFieldValue(name, value)
      }}
      {...rest}
    />
  )
}

export default TextInput
